import { LicenseWebPageDocumentFilter, LicenseWebPageResponse } from 'commons/types/DTO/bank'

export interface FilterProps {
  webPage: LicenseWebPageResponse
  onChange: (filter: LicenseWebPageDocumentFilter) => void
}
